import SurveysList from './SurveysList';
import SurveysCreate from './SurveysCreate';
import SurveysEdit from './SurveysEdit';
import SurveysShow from './SurveysShow';

export default {
    list: SurveysList,
    create: SurveysCreate,
    edit: SurveysEdit,
    show: SurveysShow
}